module.exports = __webpack_public_path__ + "static/media/henry.4fd17478.jpg";